export const PAGE_PATH = {
  homePage: "/",
  game: "/game",
  earn: "/earn",
};
